import { PencilSquareIcon } from "@heroicons/react/24/outline";
import Container from "../../../../components/container";
import IconButton from "../../../../components/icon-button";
import { CharityIssue, CharityIssueCategory } from "../../../../models";
import { CharityIssueCategoryViewModel } from "../../../../viewModels";
import CharityIssueCreateForm from "./charity-issue-create-form";
import { DeleteCharityIssueButton } from "./buttons";
import { useState } from "react";
import CharityIssueUpdateForm from "./charity-issue-update-form";

export default function CharityIssuesTable({category}:{category:CharityIssueCategoryViewModel}){
  const [charityIssue,setCharityIssue] = useState<CharityIssue>();
     return (
           <Container className="max-w-xl  text-left">
             <table className="min-w-full text-gray-900 text-left ">
               <thead className="rounded-lg text-left text-sm font-normal">
                 <tr>
                   <th scope="col" className="px-6 py-3">
                     Charity Issue
                   </th>
       
                   <th scope="col" className="px-6 py-3">
                     <span className="sr-only">Edit</span>
                   </th>
                 </tr>
               </thead>
               <tbody className="bg-white">
                 {category.charityIssues.map((item) => (
                   <tr key={item.id} className="w-full text-left border-b py-3 text-sm last-of-type:border-none [&:first-child>td:first-child]:rounded-tl-lg [&:first-child>td:last-child]:rounded-tr-lg [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg"> 
                     {charityIssue?.id === item.id ? <CharityIssueUpdateForm item={item} onCancel={() => setCharityIssue(undefined)} /> : <>
                     
                     <td className="whitespace-nowrap px-6 py-3">{item.name}</td>       
                     <td className="px-6 py-4">
                        {item.id ? (
                          <div className="flex flex-1 items-center justify-end gap-2">
                           {/* <UpdateButton id={category.id} /> */}
                           <IconButton label="Edit" icon={PencilSquareIcon} onClick={() => setCharityIssue(item)}></IconButton>
                           <DeleteCharityIssueButton charityIssue={item} />
                         </div>
                       ) : null} 
                     </td>
                     </>}
                   </tr>
                 ))}
               </tbody>
               <tfoot>
                <tr>
                  <td colSpan={2}  className="px-6 py-4">
                    <CharityIssueCreateForm category={category}></CharityIssueCreateForm>
                  </td>
                </tr>
               </tfoot>
             </table>
           </Container>
         );
       }
